import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import classNames from 'classnames'

import Text from 'components/Atoms/Text'
import Tooltip from 'components/Atoms/Tooltip'
import isLightMode from 'helpers/isLightMode'
import { useTranslation } from 'i18n-web/i18next'

const Component = styled.div`
  position: relative;
  margin-top: 4px;
  margin-left: 64px;
  cursor: pointer;

  @media (min-width: ${props => props.theme.flexboxgrid.breakpoints.sm}rem) {
    margin-left: 84px;
  }
`

const TooltipText = styled(Text)`
  display: inline-flex;
  &:first-of-type {
    margin-top: -1px;
  }
  &:before {
    content: '•';
    margin-right: 5px;
    display: block;
  }
`

const PhoneDisclaimer = ({ application, className }) => {
  const { t } = useTranslation()

  return (
    <Component className={className}>
      <Tooltip title={t('purchase.disclaimer.title')}>
        <TooltipText
          className={classNames('tiny', 'semibold', {
            contrastText: !isLightMode(application),
          })}>
          {t('purchase.disclaimer.pros.sendPassToYourPhone')}
        </TooltipText>
        <TooltipText
          className={classNames('tiny', 'semibold', {
            contrastText: !isLightMode(application),
          })}>
          {t('purchase.disclaimer.pros.preventFraud')}
        </TooltipText>
        <TooltipText
          className={classNames('tiny', 'semibold', {
            contrastText: !isLightMode(application),
          })}>
          {t('purchase.disclaimer.pros.keepYourPassSafe')}
        </TooltipText>
      </Tooltip>
    </Component>
  )
}

PhoneDisclaimer.propTypes = {
  application: PropTypes.string,
  className: PropTypes.string,
}

export default PhoneDisclaimer
